
export enum CommentNotification {
    None = 0,
    CaseWorker,
    Complete,
    Urgent
}
